// extracted by mini-css-extract-plugin
export default {"root":"DetailsHeader_root__V6mV4","inverted":"DetailsHeader_inverted__Ez7K0"};